export default "__VITE_ASSET__BIk6lgV5__"